export default __webpack_public_path__ + "static/media/wifi.4fe23a06.svg";